import React from 'react'
import './Fifthsection.css'



import Workscard from '../Workscard.js';

/*
import { Button } from 'reactstrap';
import soe from '../images/soe.png'
import Wa from '../images/Wa.png'
import ninext from '../images/ninext.png'
import Wowbii from '../images/Wowbii.png'
import Photoma from '../images/Photoma.png'
import { Link } from 'react-router-dom'; */

function Fifthsection() {
    return (
        <div>
        <div className="" id="topContainer5">
        <div className="">
        <div className="" id="works">
        <h2 id="workshead">Works</h2>
        
        </div>

        <div className=""  id="workscontent1">
        <p className="content5_1"></p>
        <p className="content5" >
        "Creativity is not about pretty pictures. It’s about compelling ideas, 
        beautifully executed, that grow business."
        </p>  
       
        </div>
      
       

      { /* <div className="jobminicard">
        <Link to ="/Soe" >
        <div className="overlay-slide" >
        <img src={soe} height="180" width="150" alt="" />
        <div>
        <h2>S.O.E</h2>   
        </div>
        </div>
        </Link>

        <Link to ="/Wacha" >
        <div className="overlay-slide2" path='/Photoma'>
        <img src={Wa} height="180" width="150" alt=""  />
        <div>
        <h2>WACHA</h2>   
        </div>
        </div>
        </Link>

        <Link to ="/Brainshare" >
        <div className="overlay-slide3" >
        <img src={ninext} height="180" width="150" alt="" />
        <div>
        <h2>NINEXT</h2>   
        </div>
        </div>
        </Link>

        <Link to ="/Wowbii" >
        <div className="overlay-slide4" >
        <img src={Wowbii} height="180" width="150" alt="" />
        <div>
        <h2>Wowbii</h2>   
        </div>
        </div>
        </Link>

        <Link to ="/Photoma" >
        <div  className="overlay-slide5"  >
        <img src={Photoma} height="180" width="150" alt="" />
        <div>
        <h2>Magic</h2>   
        </div>
        </div>
        </Link>

    </div> */ }

       

       { /*  <div className="seemore">
        <Button href="./works" id="letstalkbutton" type="button" variant="primary" ><span>See More...</span></Button>{' '}
        </div> */ }

      <div id="workscard">
        <Workscard />
        </div>
        



        
        

        
       
        
        </div>

      

        </div>
        </div>
    )
}

export default Fifthsection
